import { chakraComponents } from "chakra-react-select";
import _ from "lodash";
import { useState } from "react";
import { NavigateFunction, useNavigate, useSearchParams } from "react-router-dom";
import { EXAM } from "../../../consts/methods.consts";
import { EXAM_TAGS } from "../../../consts/tags.consts";
import { useGetQuery } from "../../../services/api.service";
import ChakraTable, { ChakraTableColumns } from "../../common/chakra-table/ChakraTable";
import { PageHeaderActions } from "../../common/page-header/PageHeader";
import { useTableDataProvider } from "../../hooks";
import { PageHeader } from "../../index";

const ExamListPage = () => {

    const navigate: NavigateFunction = useNavigate()
    const [page, setPage] = useState(1)
    const [searchKey, setSearchKey]: any = useState()

    const { data, isLoading, isFetching } = useGetQuery({
        method: EXAM.LIST,
        body: {
            page: page,
            key: searchKey
        },
        providesTags: [EXAM_TAGS.LIST]
    })

    const { dataList, paginationDetails } = useTableDataProvider(data);

    const EXAMS_COLUMNS: ChakraTableColumns = [
        {
            header: "Name",
            accessor:
                "title",
        },
    ]


    const actions: PageHeaderActions = [

        {
            text: "Create New",
            confirmation: false,
            onClick: () => {
                navigate('new')
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        }
    ]

    const onSearchHandler = (value: any) => {
        setPage(1)
        let deb = _.debounce(() => {
            setSearchKey(value)
        }, 250)

        deb()
    }

    const tableLineClickHandler = (line: any) => {
        navigate(`${_.get(line, 'name')}`)
    }

    const onPage = (page: any) => {
        setPage(page)
    }

    return (
        <>
            <div>
                <PageHeader subtitle="View and Manage Exam" title={`Exam`} actions={actions} />
                <ChakraTable onPage={onPage} onSelected={tableLineClickHandler} isFetching={isFetching} onSearch={onSearchHandler} paginationDetails={paginationDetails} isLoading={isLoading} pagination size={"sm"} header
                    title="Exams"
                    columns={EXAMS_COLUMNS} data={dataList} />
            </div>
        </>
    )
}

export default ExamListPage


const customComponents = {
    Option: ({ children, ...props }: any) => (
        <chakraComponents.Option {...props}>
            <div className="gap-2">
                <div className=" font-bold">
                    {children}
                </div>
                <div className=" italic flex  gap-3">
                    <span className="bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                        {props.data.code}
                    </span>
                    {props.data.group && (<span className="bg-yellow-100 text-yellow-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300">
                        {props.data.group}
                    </span>)}
                </div>
            </div>
        </chakraComponents.Option >
    )
};